import { createSlice } from "@reduxjs/toolkit";
import { filter } from "lodash";
import Axios from "../../utils/axiosInstance";

const initialState = {
  sellerTaskList: [],
  sellerTask: null,
  sellerTaskData: [],
  sellerTaskId: null,
};

const slice = createSlice({
  name: "sellertask",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setSellerTaskId: (state, action) => {
      state.sellerTaskId = action.payload;
    },

    // DELETE Notification
    deleteSellerTask(state, action) {
      const deleteSellerTask = filter(
        state.sellerTask,
        (sellerTask) => sellerTask.id !== action.payload
      );
      state.sellerTask = deleteSellerTask;
    },

    // GET Notification
    getSellerTaskListSuccess(state, action) {
      state.isLoading = false;
      state.sellerTaskList = action.payload;
    },

    // Create Notification
    createSellerTask(state, action) {
      state.isLoading = false;
      state.sellerTask = action.payload;
    },

    SellerTaskFindByID(state, action) {
      state.isLoading = false;
      state.sellerTaskData = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteSellerTask } = slice.actions;

// ----------------------------------------------------------------------

export function dispatchDeleteSellerTask(sellerTaskId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await Axios.delete(`seller-tasks/${sellerTaskId}`);
      dispatch(slice.actions.deleteSellerTask(sellerTaskId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchUpdateSellerTask(sellerTask) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.patch(
        `seller-tasks/${sellerTask.id}`,
        sellerTask
      );
      dispatch(slice.actions.createSellerTask(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getSellerTaskList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get("seller-tasks");
      dispatch(slice.actions.getSellerTaskListSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getSellerTaskFindByID(id) {
  return async (dispatch) => {
    if (!id) return;

    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`seller-tasks/${id}`);
      dispatch(slice.actions.SellerTaskFindByID(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
